export const tableHeadConfig = [
  { id: 1, label: 'ID', isSortable: false },
  { id: 2, label: 'Created By', isSortable: true, parameter: 'createdByUser.firstName' },
  { id: 3, label: 'Created', isSortable: true, parameter: 'createdAtUtc' },
  { id: 4, label: 'Submitted By', isSortable: true, parameter: 'submittedByUser.firstName' },
  { id: 5, label: 'Report name', isSortable: true, parameter: 'generalReportTemplate.name' },
  { id: 6, label: 'Entity', isSortable: false },
  { id: 7, label: 'Report note', isSortable: false },
  { id: 8, label: 'PDF Report', isSortable: false }
];
